import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { usePersona } from "@/lib/persona";

export const Route = createFileRoute("/app/tenants")({
  component: TenantsStub,
});

/**
 * Organizer-only route — table of all partners (tenants in the multi-tenant
 * model), with approve / suspend / impersonate actions.
 */
function TenantsStub() {
  const persona = usePersona();
  if (persona.role !== "organizer") return <Navigate to="/app" replace />;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-serif text-3xl text-palm">Partners (tenants)</h1>
        <p className="text-muted-foreground">
          Restaurants, hotels, artists, nonprofits. Approve / suspend / view.
        </p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>Wire to /api/organizer/tenants in M1</CardTitle>
          <CardDescription>
            Table view of `partners` joined with their role-specific detail rows. Filter by role,
            status. Bulk actions for approval queue.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Reads use TanStack Query with 60s staleTime. Bulk approve mutations fire audit-log
          entries with the actor's Cognito sub.
        </CardContent>
      </Card>
    </div>
  );
}
